// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"multiselect_checkbox__1HcIg"};